import React from 'react';
import { connect } from 'react-redux';
import { Box } from '@drone-js/core';
import { CancellationType } from 'gql/autogen/CancellationType';
import { CancellationPolicyCardProps, mapCancellationPolicyCardProps } from 'component/page/detail/CancellationPolicyCard/CancellationPolicyCard.selectors';
import CancellationPolicyItem from 'component/page/detail/CancellationPolicyCard/CancellationPolicyItem';
import CancellationPolicyMessage from 'component/page/detail/CancellationPolicyCard/CancellationPolicyMessage';

const CancellationPolicyCard: React.FC<CancellationPolicyCardProps> = (props) => {
    const isNonRefundable = props.cancellationType === CancellationType.NON_REFUNDABLE;
    if (isNonRefundable || !props.sortedPolicies || props.sortedPolicies.length === 0) {
        return <CancellationPolicyMessage isFreeCancellation={!isNonRefundable} />;
    }

    const policyCount = props.sortedPolicies.length || 0;

    return (
        <Box data-testid="activities-cancellation-policy-container" mt="8" mb="16">
            {props.sortedPolicies.map((policy, index) => {
                return <CancellationPolicyItem key={policy.hoursFrom} policy={policy} index={index} policyCount={policyCount} />;
            })}
        </Box>
    );
};
CancellationPolicyCard.displayName = 'CancellationPolicyCard';

export default connect(mapCancellationPolicyCardProps)(CancellationPolicyCard);
